/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

// import styled from 'styled-components';
import NpsRadioWithLabel from './NpsRadioWithLabel';
import { Color } from '../../../asset/styles';

// const StyledBox = styled.div`
//   display: flex;
//   width: 100%;
// `;

/**
 * Nps 5段階選択 radio {@link NpsRadioWithLabel} を作成します 【例】あなたはこのキャンペーンを家族や友達に薦めたいと思いますか？
 * - inspector - element debug 用に `.NpsRadios` class name を付与します
 * @param {Array<{value: string, name: string}>} optionValues radio value 属性値
 * @param {string} name input[type='radio'] name
 * @param {number|string} alreadyChecked - checked radio button data-index number - popup / embedded 切替時に checked 維持するのに使用します
 * @param {boolean} generator generator flag
 * @param {boolean} disabled - radio disabled attribute
 * @param {*} props React.props radio へ付与します
 * @return {*} React.node - 5段階 radio container を返します
 * @constructor
 * @since 20191210 - add alreadyChecked argument
 */
const NpsRadios = ({
  optionValues,
  name,
  alreadyChecked,
  generator,
  disabled,
  ...props
}) =>
  // <StyledBox className={'NpsRadios'}>
  //   {optionValues.map((data, index) => {
  //     const key = `npsRadio-${index}`;
  //     // console.log('NpsRadios', key, name)
  //     return (
  //       <NpsRadioWithLabel
  //         key={key}
  //         id={key}
  //         color={Color.permission[index]}
  //         name={name}
  //         label={index + 1}
  //         value={data.value}
  //         data-index={index}
  //         {...props}
  //       />
  //     );
  //   })}
  // </StyledBox>
  // optionValues.map((data, index) => {
  //   const key = `npsRadio-${index}`;
  //   console.log('NpsRadios', alreadyChecked, index, props)
  //   return (
  //     <NpsRadioWithLabel
  //       key={key}
  //       id={key}
  //       color={Color.permission[index]}
  //       name={name}
  //       label={index + 1}
  //       value={data.value}
  //       data-index={index}
  //       checked={alreadyChecked === index}
  //       {...props}
  //     />
  //   )
  // });
  optionValues.map((data, index) => {
    const key = `npsRadio-${index}`;
    // console.log('NpsRadios', alreadyChecked, index, props)
    return generator ? (
      <NpsRadioWithLabel
        key={key}
        id={key}
        color={Color.permission[index]}
        name={name}
        label={index + 1}
        value={data.value}
        data-index={index}
        checked={alreadyChecked === index}
        disabled={disabled}
        {...props}
      />
    ) : (
      <NpsRadioWithLabel
        key={key}
        id={key}
        color={Color.permission[index]}
        name={name}
        label={index + 1}
        value={data.value}
        data-index={index}
        disabled={disabled}
        {...props}
      />
    );
  });

NpsRadios.propTypes = {
  optionValues: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    })
  ).isRequired,
};

export default NpsRadios;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/nps/children/NpsRadios.js